import React, { useState } from "react";
import {
  useTable,
  List,
  EditButton,
  ShowButton,
  DeleteButton,
  CreateButton,
} from "@refinedev/antd";
import { Table, Space, Input, Select } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { DELETE_DOCUMENT_TEMPLATE_MUTATION, DOCUMENT_TEMPLATE_LIST_QUERY } from "./queries";

interface IDocumentTemplateRow {
  id: string;
  documentName: string;
  category: string;
  tag: string;
  createdAt: string;
  updatedAt: string;
}

export const DocumentTemplateList: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [categoryFilter, setCategoryFilter] = useState<string>("");
  const [tagFilter, setTagFilter] = useState<string>("");

  const { tableProps } = useTable<IDocumentTemplateRow>({
    resource: "documentTemplates",
    initialSorter: [{ field: "createdAt", order: "asc" }],
    initialPageSize: 10,
    meta: {
      gqlQuery: DOCUMENT_TEMPLATE_LIST_QUERY,
    },
    filters: {
      permanent: [
        ...(categoryFilter
          ? [{ field: "category", operator: "eq" as const, value: categoryFilter }]
          : []),
        ...(tagFilter
          ? [{ field: "tag", operator: "eq" as const, value: tagFilter }]
          : []),
      ],
    },
  });

  const dataSource: IDocumentTemplateRow[] = (
    (tableProps as any)?.dataSource || []
  ).filter(
    (row: IDocumentTemplateRow) =>
      !searchTerm ||
      row.documentName?.toLowerCase?.().includes(searchTerm.toLowerCase()) ||
      row.category?.toLowerCase?.().includes(searchTerm.toLowerCase()) ||
      row.tag?.toLowerCase?.().includes(searchTerm.toLowerCase())
  );

  return (
    <List
      headerProps={{
        extra: (
          <Space>
            <Input
              placeholder="Search by name, category, or tag..."
              prefix={<SearchOutlined />}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onPressEnter={(e) => setSearchTerm(e.currentTarget.value)}
              style={{ width: 280 }}
            />
            <Select
              placeholder="Filter by Category"
              value={categoryFilter}
              onChange={setCategoryFilter}
              style={{ width: 140 }}
              allowClear
            >
              <Select.Option value="CONTRACT">Contract</Select.Option>
              <Select.Option value="AGREEMENT">Agreement</Select.Option>
              <Select.Option value="POLICY">Policy</Select.Option>
              <Select.Option value="FORM">Form</Select.Option>
            </Select>
            <Select
              placeholder="Filter by Tag"
              value={tagFilter}
              onChange={setTagFilter}
              style={{ width: 140 }}
              allowClear
            >
              <Select.Option value="LEGAL">Legal</Select.Option>
              <Select.Option value="FINANCE">Finance</Select.Option>
              <Select.Option value="HR">HR</Select.Option>
              <Select.Option value="PROCUREMENT">Procurement</Select.Option>
            </Select>
            <CreateButton />
          </Space>
        ),
      }}
    >
      <Table {...tableProps} dataSource={dataSource as any} rowKey="id">
        <Table.Column dataIndex="documentName" title="Document Name" sorter />
        <Table.Column dataIndex="category" title="Category" sorter />
        <Table.Column dataIndex="tag" title="Tag" sorter />
        <Table.Column dataIndex="createdAt" title="Created Date" sorter />
        <Table.Column
          title="Actions"
          dataIndex="actions"
          render={(_text: string, record: IDocumentTemplateRow) => (
            <Space>
              <EditButton
                size="small"
                recordItemId={record.id}
                resource="documentTemplates"
              />
              <DeleteButton
                size="small"
                recordItemId={record.id}
                meta={{ gqlMutation: DELETE_DOCUMENT_TEMPLATE_MUTATION }}
                resource="documentTemplates"
              />
              <ShowButton
                size="small"
                recordItemId={record.id}
                resource="documentTemplates"
              />
            </Space>
          )}
        />
      </Table>
    </List>
  );
};